<template>
  <el-button type="text" @click="$emit('update:flag', !flag)">
    <div class="font-small" v-if="!flag">展开筛选<i class="el-icon-arrow-down el-icon--right" /></div>
    <div class="font-small" v-else>收起筛选<i class="el-icon-arrow-up el-icon--right" /></div>
  </el-button>
</template>
<script>
export default {
  props: {
    flag: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {};
  },
};
</script>
